export const ZERO_FILE_SIZE = '0 Bytes';

export const FILE_SIZES = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

export const MAX_SIZE = 10000000;
